function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isArray, isSameTypeVNode } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('CardAdvance'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-card-advance'
    },
    title: {
      type: String,
      default: ''
    },
    extra: {
      type: String,
      default: ''
    },
    bordered: {
      type: Boolean,
      default: true
    },
    headStyle: {
      type: Object,
      default: null
    },
    bodyStyle: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    hoverable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'inner'].indexOf(val) > -1;
      }
    },
    cover: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          loading = this.loading,
          bordered = this.bordered,
          hoverable = this.hoverable,
          type = this.type;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-loading"), loading), _defineProperty(_ref, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_ref, "".concat(prefixCls, "-hoverable"), hoverable), _defineProperty(_ref, "".concat(prefixCls, "-type-").concat(type), !!type), _ref;
    }
  },
  methods: {
    hasGrid: function hasGrid() {
      var slotDefault = this.$slots.default;
      var ret = false;

      if (slotDefault) {
        for (var i = 0, l = slotDefault.length; i < l; i += 1) {
          if (isSameTypeVNode(slotDefault[i], 'isCardGroupType')) {
            ret = true;
            break;
          }
        }
      }

      return ret;
    },
    renderHeader: function renderHeader() {
      var h = this.$createElement;
      var _this$$slots = this.$slots,
          slotTitle = _this$$slots.title,
          slotExtra = _this$$slots.extra,
          prefixCls = this.prefixCls,
          title = this.title,
          extra = this.extra,
          headStyle = this.headStyle;
      var titleContent = slotTitle || title;
      var extraContent = slotExtra || extra;
      var headerNode = null;

      if (titleContent || extraContent) {
        headerNode = h("div", {
          "class": "".concat(prefixCls, "-head"),
          "style": headStyle
        }, [h("div", {
          "class": "".concat(prefixCls, "-head-wrapper")
        }, [titleContent ? h("div", {
          "class": "".concat(prefixCls, "-head-title")
        }, [titleContent]) : null, extraContent ? h("div", {
          "class": "".concat(prefixCls, "-extra")
        }, [extraContent]) : null])]);
      }

      return headerNode;
    },
    renderCover: function renderCover() {
      var h = this.$createElement;
      var slotCover = this.$slots.cover,
          prefixCls = this.prefixCls,
          cover = this.cover;
      var coverContent = slotCover || cover;
      return coverContent ? h("div", {
        "class": "".concat(prefixCls, "-cover")
      }, [coverContent]) : null;
    },
    renderBody: function renderBody() {
      var h = this.$createElement;
      var slotDefault = this.$slots.default,
          prefixCls = this.prefixCls,
          bodyStyle = this.bodyStyle;
      return h("div", {
        "class": "".concat(prefixCls, "-body"),
        "style": bodyStyle
      }, [slotDefault]);
    },
    renderActions: function renderActions() {
      var h = this.$createElement;
      var slotActions = this.$slots.actions,
          prefixCls = this.prefixCls;
      var actionNode = null;

      if (isArray(slotActions) && slotActions.length > 0) {
        var actionW = "".concat(100 / slotActions.length, "%");
        actionNode = h("ul", {
          "class": "".concat(prefixCls, "-actions")
        }, [slotActions.map(function (action, i) {
          return h("li", {
            "key": "action-".concat(i),
            "style": "width: ".concat(actionW)
          }, [h("span", [action])]);
        })]);
      }

      return actionNode;
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        classes = this.classes,
        renderHeader = this.renderHeader,
        renderCover = this.renderCover,
        renderBody = this.renderBody,
        renderActions = this.renderActions,
        hasGrid = this.hasGrid;
    return h("div", {
      "class": [classes, _defineProperty({}, "".concat(prefixCls, "-contain-grid"), hasGrid())]
    }, [renderHeader(), renderCover(), renderBody(), renderActions()]);
  }
};